export enum BanksActionType {
    GETTING_BANKS = 'GETTING_BANKS',
    GETTING_BANKS_SUCCESS = 'GETTING_BANKS_SUCCESS',
    GETTING_BANKS_FAILURE = 'GETTING_BANKS_FAILURE'
}
